import { Observable } from 'rxjs/Observable';

export class DashboardUtils {
  static totalAsStringClampedTo99(totalObs: Observable<number>): Observable<string> {
    return totalObs.map(total => total >= 99 ? '99+' : String(total));
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/utils/dashboard-util.ts